module.exports = __webpack_public_path__ + "img/craftBannerAwnings.1d1aef7.webp";